export default "__VITE_ASSET__cf4082d1__"